import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaFileExcel, FaFilePdf, FaRegFileWord } from "react-icons/fa";
import {
  createFile,
  deleteFile,
  deleteFolder,
  detailFolder,
  downloadFolder,
  folderFullDetail,
  getFolders,
} from "../../../../services/workspace/photos.service";
import { v4 as uuidv4 } from "uuid";
import ConfirmModal from "../../../components/modals/ConfirmModel";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../components/modals/commonModel";
// import FolderForm from "../../../components/forms/photos/folderForm";
import {
  _allExtensions,
  _formatFileSize,
  _userRole,
  printDateAndTime,
} from "../../../../utils/common";
// import StudentFolderShareForm from "../../../components/forms/photos/folderShareStudentForm";
import useUserRole from "../../../../hooks/useUserRole";
import toast from "react-hot-toast";
// FileUploadModal removed - using simple photo upload system
import noFolder from "../../../assets/lottie/nofolder.json";
import { useSelector } from "react-redux";
// useFileUploaderGallary removed - using simple photo upload system
import FloatingActionButton from "./actionButtons";
import image from "../../../assets/images/image.png";
import video from "../../../assets/images/video.png";
import BottomDrawer from "../../common/drawer/bottomDrawer";
import FileAndFolderAction from "./fileAndFolderAction";
import { FolderDetails } from "./folderDetails";
import Folder from "./folder";
import { FilePreviewModal } from "../../../components/filePreview/commonFilePreview";
import { RxCross2 } from "react-icons/rx";
import DefaultCheckbox from "../../../components/inputs/defaultCheckbox";
import DefaultButton from "../../../components/buttons/defaultButton";
import { HiOutlineTrash } from "react-icons/hi";
import { downloadFile } from "../../../../utils/helper";
import NoFolderFound from "../../../components/noData/noFolderFound";
import FolderForm from "../../../components/forms/fileManager/folderForm";
import { selectCompletedUploads } from "../../../../store/slices/fileUpload.slice";

const ViewFolder = () => {
  const { id } = useParams();
  const idRef = useRef(id);
  const navigate = useNavigate();
  const role = useUserRole();
  
  // Monitor completed uploads to refresh folder list
  const completedUploads = useSelector(selectCompletedUploads);
  const completedUploadsRef = useRef([]);

  // Keep the ref in sync with the URL parameter
  useEffect(() => {
    idRef.current = id;
   
  }, [id]);

  // const { storage_limit, storage_used } = useSelector(
  //   (state) => state.workspace
  // );
  // const storagePercentage = (storage_used / storage_limit) * 100;

  const [refresh, setRefresh] = useState(false);
  const [isStudent, setIsStudent] = useState(false);
  const [isStaff, setIsStaff] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isFolderModalOpen, setIsFolderModalOpen] = useState(false);
  const [folderToEdit, setFolderToEdit] = useState(null);
  const [folderToDelete, setFolderToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [tableData, setTableData] = useState([]);
  const [folders, setFolders] = useState([]);
  const [folderDetails, setFolderDetails] = useState(null);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDeleteFileModalOpen, setIsDeleteFileModalOpen] = useState(false);
  const [deleteFileList, setDeleteFileList] = useState([]);
  const [actionLoading, setActionLoading] = useState(false);

  useEffect(() => {
    if (!folderDetails) return;

    const basePath = "/photos";
    const breadcrumbItems = [{ label: "Photos", path: basePath }];

    // Walk up the parent chain
    let currentFolder = folderDetails.folder;
    const stack = [];

    while (currentFolder) {
      stack.unshift({
        label: currentFolder.name,
        path: `${basePath}/${currentFolder.uuid}`,
      });
      currentFolder = currentFolder.folder; // depends on your API response
    }

    setItems([...breadcrumbItems, ...stack]);
  }, [folderDetails, id]);

  const getFoldersList = async () => {
    try {
      setIsLoading(true);
      const response = idRef.current
        ? await detailFolder(idRef.current)
        : await getFolders();
      setFolderDetails(response);

      setFolders(response?.folder?.folders || []);
      setTableData(response?.documents || []);
    } catch (error) {
      console.error("Error fetching folders:", error);
      // toast.error("Failed to load folders and files.");
    } finally {
      setIsLoading(false);
    }
  };

  // const fileUpload = async () => {
  //   setIsUploading(true);

  //   try {
  //     const payload = {
  //       documents: fileToUpload,
  //       folder_id: idRef.current, // Use the ref value instead of id directly
  //     };
  //     const response = await createFile(payload);
  //     if (response) {
  //       setIsUploadFileModalOpen(false);
  //       setRefresh(!refresh);
  //     }
  //   } catch (error) {
  //     console.error("Error uploading file:", error);
  //     toast.error("Failed to upload file. Please try again.");
  //   } finally {
  //     setIsUploading(false);
  //   }
  // };

  useEffect(() => {
    getFoldersList();
  }, [id, refresh]);

  // Monitor completed uploads and refresh folder list when new uploads complete
  useEffect(() => {
    const currentCompletedCount = completedUploads.length;
    const previousCompletedCount = completedUploadsRef.current.length;
    
    // If we have new completed uploads, refresh the folder list
    if (currentCompletedCount > previousCompletedCount) {
      const newCompletedUploads = completedUploads.slice(previousCompletedCount);
      
      // Check if any of the new completed uploads belong to the current folder
      const hasRelevantUpload = newCompletedUploads.some(upload => 
        upload.folderId === idRef.current || (!upload.folderId && !idRef.current)
      );
      
      if (hasRelevantUpload) { 
        getFoldersList();
      }
    }
    
    // Update the ref to track current completed uploads
    completedUploadsRef.current = [...completedUploads];
  }, [completedUploads]);

  const handleEdit = (id) => {
    const folderToEdit = folders.find((folder) => folder.id === id);
    setFolderToEdit(folderToEdit);
    setIsFolderModalOpen(true);
  };

  const handleView = (folder) => {
    const basePath = isStaff
      ? "/staff/photos"
      : isStudent
      ? "/student/photos"
      : "/photos";
    navigate(`${basePath}/${folder.uuid}`);
  };

  const confirmDelete = (id) => {
    setFolderToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const confirmDeleteFile = (id) => {
    // setFileToDelete(id);
    setIsDeleteFileModalOpen(true);
  };

  const handleDeleteFileList = (id) => {
    const isExist = deleteFileList.includes(id);
    if (isExist) {
      setDeleteFileList((prev) => prev.filter((item) => item !== id));
    } else {
      setDeleteFileList((prev) => [...prev, id]);
    }
  };

  const handleDelete = async () => {
    try {
      setActionLoading(true);
      const response = await deleteFolder(folderToDelete);
      if (response.status === 200) {
        setFolders(folders.filter((folder) => folder.uuid !== folderToDelete));
        setIsDeleteModalOpen(false);
        setFolderToDelete(null);
        toast.success("Folder deleted successfully");
      } else {
        toast.error("Error deleting folder");
      }
    } catch (error) {
      toast.error("Error deleting folder");
    } finally {
      setActionLoading(false);
    }
  };

  useEffect(() => {
    setDeleteFileList([]);
  }, []);

  const handleDeleteFile = async () => {
    try {
      setActionLoading(true);
      const payload = {
        media_uuids: deleteFileList,
      };

      const response = await deleteFile(payload);
      if (response.status === 200) {
        setTableData(
          tableData.filter((file) => !deleteFileList.includes(file.uuid))
        );
        setIsDeleteFileModalOpen(false);
        setDeleteFileList([]);
        toast.success("File deleted successfully");
      } else {
        toast.error("Error deleting file");
      }
    } catch (error) {
      toast.error("Error deleting file");
    } finally {
      setActionLoading(false);
    }
  };

  const closeFolderModal = () => {
    setIsFolderModalOpen(false);
    setIsShareModalOpen(false);
    setFolderToEdit(null);
  };

  const getShareList = async (folder) => {
    return await folderFullDetail(folder?.uuid);
  };

  const handleShare = async (folder) => {
    const res = await getShareList(folder, { with: "folderUsers" });

    setIsShareModalOpen({ ...folder, shareList: res });
  };

  const handleDownloadFolder = async (folder) => {
    try {
      const response = await downloadFolder({ folder_id: folder.uuid });
      if (response.status === 200) {
        toast.success("Folder downloaded successfully");
      } else {
        toast.error(response.data?.message || "Error downloading folder");
      }
    } catch (error) {
      toast.error("Error downloading folder");
    }
  };

  useEffect(() => {
    setIsStudent(role === _userRole.STUDENT);
    setIsStaff(role === _userRole.STAFF);
  }, [role]);

  const _formatFiles = useCallback((files) => {
    return Array.from(files).map((file) => ({
      name: file.name,
      size: file.size,
      type: file.type,
      lastModified: file.lastModified,
      localpreview: URL.createObjectURL(file),
      loading: true,
      uuid: uuidv4(),
      // Don't store the File object in Redux state - it's not serializable
      // file: file, // Removed to fix Redux serialization warning
      info: "",
      accept: "",
    }));
  }, []);

  const [isOpenSheet, setIsOpenSheet] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);

  const onDetails = (folder) => {
    setSelectedFolder(folder);
    setIsOpenSheet(true);
  };

  const getFileIcon = (extension, file) => {
    if (["jpg", "jpeg", "png", "gif", "svg"].includes(extension)) {
      return <img src={file.url} alt="img" className=" h-full rounded-md" />;
    } else if (extension === "pdf") {
      return <FaFilePdf />;
    } else if (["xls", "xlsx", "csv"].includes(extension)) {
      return <FaFileExcel />;
    }
    return <FaRegFileWord />;
  };

  const triggerAdd = () => {
    setIsFolderModalOpen(true);
  };

  const closePreview = () => {
    setShowPreview(false);
    setSelectedFile(null);
  };

  const openPreview = (file) => {
    setSelectedFile(file);
    setShowPreview(true);
  };

  const onDownload = (file) => {
    downloadFile(file.url, file.name);
  };

  return (
    <div className="flex flex-col gap-2 h-full">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={false}
        isFilter={false}
        buttons={
          role === _userRole.WORKSPACE_ADMIN || role === _userRole.STAFF ? (
            <div>
              {deleteFileList && deleteFileList.length > 0 && (
                <div className="flex items-center gap-4">
                  <span
                    className="underline cursor-pointer text-primary-950"
                    onClick={() => setDeleteFileList([])}
                  >
                    Clear
                  </span>

                  <DefaultButton
                    onClick={confirmDeleteFile}
                    icon={<HiOutlineTrash />}
                    classnames={"!w-10 !h-10 bg-red-600"}
                  />
                </div>
              )}
            </div>
          ) : null
        }
      />
      <div className="h-[calc(100vh-150px)] bg-white">
        {isLoading ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 bg-white p-4">
            {[...Array(4)].map((_, index) => (
              <FolderSkeleton key={index} />
            ))}
          </div>
        ) : folders.length === 0 && (!tableData || tableData.length === 0) ? (
          !(
            folderDetails?.folder?.documents &&
            folderDetails.folder.documents.length > 0
          ) && (
            <div className="w-full h-full flex items-center justify-center bg-white p-4">
              <NoFolderFound
                role
                message="No Folder Found"
                lottie={noFolder}
                folderFucnction={() => setIsFolderModalOpen(true)}
                // fileLink removed - uploads now handled by FloatingActionButton
              />
            </div>
          )
        ) : (
          <>
            {folders.length > 0 && (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 bg-white p-4">
                {folders.map((folder) => (
                  <Folder
                    key={folder.id}
                    folder={folder}
                    onEdit={handleEdit}
                    onView={handleView}
                    onDelete={confirmDelete}
                    onShare={handleShare}
                    onDownloadFolder={handleDownloadFolder}
                    isMainPage={true}
                    isStudent={isStudent}
                  />
                ))}
              </div>
            )}
          </>
        )}

        {folderDetails?.folder?.documents &&
          folderDetails.folder.documents.length > 0 && (
            <div className="flex flex-col gap-2 bg-white p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {folderDetails?.folder?.documents.map((file) => {
                  const extension = file.name.split(".").pop().toLowerCase();
                  return (
                    <div
                      key={file.uuid}
                      className="bg-gray-50 hover:bg-primary-100 rounded-md cursor-pointer"
                      onClick={() =>
                        deleteFileList && deleteFileList.length > 0
                          ? handleDeleteFileList(file.uuid)
                          : openPreview(file)
                      }
                    >
                      {/* File header */}
                      <div className="flex flex-row justify-between items-center pt-4 px-2 rounded-t-md relative">
                        <div className="flex flex-row gap-2 items-center ">
                          {deleteFileList && deleteFileList.length > 0 && (
                            <DefaultCheckbox
                              value={deleteFileList.includes(file.uuid)}
                              onChange={() => handleDeleteFileList(file.uuid)}
                            />
                          )}

                          {["jpg", "jpeg", "png", "gif", "svg"].includes(
                            extension
                          ) ? (
                            <div className="w-6 h-6">
                              <img
                                src={image}
                                alt="img"
                                className="w-full h-full rounded-md"
                              />
                            </div>
                          ) : (
                            <div className="w-6 h-6">
                              <img
                                src={video}
                                alt="file"
                                className="w-full h-full rounded-md"
                              />
                            </div>
                          )}

                          <h2 className="max-w-36 truncate">{file.name}</h2>
                        </div>

                        {!deleteFileList || deleteFileList.length <= 0 ? (
                          <div onClick={(e) => e.stopPropagation()}>
                            <FileAndFolderAction
                              doc={file}
                              onDetails={onDetails}
                              onRename={handleEdit}
                              onView={openPreview}
                              onDelete={handleDeleteFileList}
                              onShare={handleShare}
                              access={folderDetails?.access}
                              onDownload={onDownload}
                            />
                          </div>
                        ) : null}
                      </div>

                      {/* File body */}
                      <div className="flex flex-col items-center gap-2 p-2">
                        <div className="rounded-md flex items-center justify-center text-[100px] text-primary-950 w-full bg-black h-36">
                          {getFileIcon(extension, file)}
                        </div>
                        <div className="min-w-0 w-full flex justify-between items-center gap-2">
                          <p className="text-xs font-medium text-primary-950 truncate w-36">
                            {file.name}
                          </p>
                          <p className="text-xs text-gray-500">
                            {_formatFileSize(file.size)}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
      </div>

      {showPreview && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="rounded-lg max-h-[calc(100%-100px)] container min-h-96 mx-auto overflow-hidden relative">
            <button
              onClick={closePreview}
              className="absolute top-4 right-4 text-primary-950 rounded-full p-2 bg-primary-50 border text-2xl hover:bg-primary-100"
            >
              <RxCross2 />
            </button>
            <FilePreviewModal file={selectedFile} />
          </div>
        </div>
      )}

      {/* <input
        type="file"
        id="fileInput"
        ref={fileInputRef}
        className="hidden"
        onChange={handleFileChange}
        placeholder="Upload File"
        accept="image/jpeg,image/png"
        multiple
      /> */}
      {isFolderModalOpen && (
        <CommonModal
          modalSize="lg"
          headerTitle="Add Folder"
          onClose={closeFolderModal}
          show={isFolderModalOpen}
        >
          <FolderForm
            isModal={true}
            closeModal={closeFolderModal}
            id={id}
            editFolder={folderToEdit}
            refresh={refresh}
            setRefresh={setRefresh}
          />
        </CommonModal>
      )}

      {/* Upload functionality now handled by FloatingActionButton */}
      <ConfirmModal
        title="Are You Sure?"
        message="Are you sure you want to delete this? This action is permanent and cannot be reversed."
        isOpen={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        onConfirm={handleDelete}
        loading={actionLoading}
      />
      <ConfirmModal
        title="Are You Sure?"
        message="Are you sure you want to delete this? This action is permanent and cannot be reversed."
        isOpen={isDeleteFileModalOpen}
        onCancel={() => setIsDeleteFileModalOpen(false)}
        onConfirm={handleDeleteFile}
        loading={actionLoading}
      />
      {isShareModalOpen && (
        <CommonModal
          modalSize="2xl"
          headerTitle="Share Folder"
          onClose={closeFolderModal}
          show={isShareModalOpen}
        >
          {/* <div className="flex flex-col gap-2 overflow-auto">
            <StudentFolderShareForm
               isModal={true}
               closeModal={closeFolderModal}
               folder={isShareModalOpen}
               actionLoading={actionLoading}
               refresh={refresh}
               setRefresh={setRefresh}
            />
          </div> */}
        </CommonModal>
      )}

      <FloatingActionButton
        triggerAdd={triggerAdd}
        showAdd={!folderDetails?.parent}
        showUpload={true}
        folderId={id} // Pass the current folder ID for uploads
      />

      <BottomDrawer
        isOpen={isOpenSheet}
        setIsOpen={setIsOpenSheet}
        title="Folder details"
        classNames="!w-[340px]"
        position="right"
      >
        {selectedFolder && <FolderDetails folder={selectedFolder} />}
      </BottomDrawer>
    </div>
  );
};

const FolderSkeleton = () => (
  <div className="bg-gray-100 rounded-lg p-4 flex flex-col gap-4 justify-between items-center animate-pulse relative">
    <div className="absolute top-4 right-4 h-5 text-right w-2 bg-gray-300" />
    <div className="h-20 w-28 bg-gray-300 rounded-md" />
    <div className="h-4 w-28 bg-gray-300 rounded" />
  </div>
);

export default ViewFolder;
